/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CustomerPreview } from './CustomerPreview.js';
import {
    CustomerPreviewFromJSON,
    CustomerPreviewFromJSONTyped,
    CustomerPreviewToJSON,
} from './CustomerPreview.js';

/**
 * 
 * @export
 * @interface GetCustomerPreviewResponse
 */
export interface GetCustomerPreviewResponse {
    /**
     * 
     * @type {CustomerPreview}
     * @memberof GetCustomerPreviewResponse
     */
    data?: CustomerPreview;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPreviewResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPreviewResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPreviewResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetCustomerPreviewResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetCustomerPreviewResponse interface.
 */
export function instanceOfGetCustomerPreviewResponse(value: object): boolean {
    return true;
}

export function GetCustomerPreviewResponseFromJSON(json: any): GetCustomerPreviewResponse {
    return GetCustomerPreviewResponseFromJSONTyped(json, false);
}

export function GetCustomerPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CustomerPreviewFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetCustomerPreviewResponseToJSON(value?: GetCustomerPreviewResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': CustomerPreviewToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

